import select2 from "select2";
select2($);
$(document).ready(function () {
  $("#loader").hide();
  $(".select2").select2({
    placeholder: function () {
      return $(this).data("placeholder");
    },
    allowClear: true,
    width: "100%",
  });

  $("#departement-filter, #location-filter").on("change", function () {
    var departement = $("#departement-filter").val();
    var location = $("#location-filter").val();
    $("#loader").show();
    $(".job-list").addClass("loading");
    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: {
        action: "filter_jobs",
        departement: departement,
        location: location,
      },
      success: function (response) {
        $("#loader").hide();
        $(".job-list").removeClass("loading");
        $(".job-list .row").html(response);
      },
    });
  });
  if (document.body.classList.contains("single-offres_emploi")) {
    localStorage.removeItem("jobTitle");
  }
  var postulerButton = document.getElementById("postuler-button");
  if (postulerButton) {
    postulerButton.addEventListener("click", function () {
      var jobTitle = this.getAttribute("data-job-title");
      localStorage.setItem("jobTitle", jobTitle);
    });
  }

  var jobTitle = localStorage.getItem("jobTitle");
  if (jobTitle) {
    var formField = document.querySelector('.wpcf7-form [name="job-title"]');
    if (formField) {
      formField.value = jobTitle;
    }
    var jobTitleDisplay = document.getElementById('job-title-display');
    if (jobTitleDisplay) {
        jobTitleDisplay.textContent = jobTitle;
    }
  }
  

  
});
